export default __webpack_public_path__ + "static/sweepstakes-grand-4-cad886d0aa16202d5450cc67cc23e383.jpg";